import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTbMod = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.4435 5.34396C14.6728 4.88535 15.3272 4.88535 15.5565 5.34396L23.1537 20.5382H28.3778C28.7214 20.5382 29 20.8168 29 21.1604V23.6493C29 23.993 28.7214 24.2715 28.3778 24.2715H21.2309C20.9952 24.2715 20.7798 24.1384 20.6744 23.9276L15 12.5789L9.32564 23.9276C9.22024 24.1384 9.00479 24.2715 8.76911 24.2715H1.62222C1.27858 24.2715 1 23.993 1 23.6493V21.1604C1 20.8168 1.27858 20.5382 1.62222 20.5382H6.84634L14.4435 5.34396Z",
		fill: "#FF8800"
	})
});
export default SvgTbMod;
